class FilterSelect {

  constructor() {
    this.selectFilterTrigger = document.querySelector('.js-filter-models');
    this.targetElement = document.querySelector('.js-filter-models--target');
  }

  init(){
    this.filter();
    this.addChangeEvent();
  }

  /**
   * Filter select optgroups based on another selects value
   *
   * @memberof FilterSelect
   */
  filter() {
    const optGroups = [...this.targetElement.querySelectorAll('optgroup')];
    const selectedMake = this.selectFilterTrigger.value;
    optGroups.forEach(group => {
      if(group.label === selectedMake) {
        group.hidden = false;
      } else {
        group.hidden = true;
        group.querySelectorAll('option')
          .forEach(option => option.selected = false);
      }
    });
    this.targetElement.disabled = !optGroups.some(group => group.label === selectedMake);
    this.targetElement.dispatchEvent(new Event('change'));
  }

  /**
   * Add change event to the filter functionality
   *
   * @memberof FilterSelect
   */
  addChangeEvent() {
    this.selectFilterTrigger.addEventListener('change', () => {
      this.filter();
    });
  }

}

export default new FilterSelect();
